import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-table', {
  mixins: [eventListenerMixin],

  properties: {
    selectable: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    if (this.selectable) {
      this.listenTo(this.querySelector('table thead'), {
        'tr-checkbox-field:change': this.handleAllCheckboxChange.bind(this),
      });

      this.listenTo(this.querySelector('table tbody'), {
        'tr-checkbox-field:change': this.handleRowCheckboxChange.bind(this),
      });
    }
  },

  disconnected() {
    this.stopListening();
  },

  getSelectedRows() {
    return Array.prototype.slice.call(this.querySelectorAll('tbody > tr.selected'));
  },

  getRows() {
    return Array.prototype.slice.call(this.querySelectorAll('tbody > tr'));
  },

  handleAllCheckboxChange(event) {
    if (event.detail.checked) {
      this.selectAllRows();
    } else {
      this.unselectAllRows();
    }

    this.namespacedTrigger('selectedChange', {
      detail: this.getSelectedRows(),
      bubbles: true,
    });
  },

  handleRowCheckboxChange(event) {
    const row = closest(event.target, 'tr');

    this.toggleSelectRow(row, event.detail.checked, true);
    this.namespacedTrigger('selectedChange', {
      detail: this.getSelectedRows(),
      bubbles: true,
    });

    this.refreshAllCheckbox();
  },

  toggleSelectRow(row, selected, notifyChange = false) {
    if (!this.selectable) return;

    const currentSelected = row.classList.contains('selected');
    if (selected === currentSelected || row.classList.contains('disabled')) return;

    row.classList.toggle('selected', selected);

    const checkbox = row.querySelector('.td-checkbox tr-checkbox-field');
    if (checkbox.checked !== selected) checkbox.checked = selected;

    if (notifyChange) {
      this.namespacedTrigger('rowSelected', {
        detail: { row, selected },
        bubbles: true,
      });
    }
  },

  selectRow(row, notifyChange = false) {
    this.toggleSelectRow(row, true, notifyChange);
  },

  unselectRow(row, notifyChange = false) {
    this.toggleSelectRow(row, false, notifyChange);
  },

  selectAllRows() {
    const rows = this.querySelectorAll('tbody > tr');
    Array.prototype.forEach.call(rows, row => this.selectRow(row, true));
  },

  unselectAllRows() {
    const rows = this.querySelectorAll('tbody > tr');
    Array.prototype.forEach.call(rows, row => this.unselectRow(row, true));
  },

  refreshAllCheckbox() {
    const allCheckbox = this.querySelector('.th-checkbox tr-checkbox-field');

    if (this.querySelectorAll('tbody > tr:not(.selected)').length === 0) {
      allCheckbox.checked = true;
      allCheckbox.indeterminate = false;
    } else if (this.getSelectedRows().length > 0) {
      allCheckbox.checked = false;
      allCheckbox.indeterminate = true;
    } else {
      allCheckbox.checked = false;
      allCheckbox.indeterminate = false;
    }
  },
});
